import { type DataTableColumn, type DataTableDefaultColumnProps } from 'mantine-datatable'
import { useTranslations } from 'next-intl'
import { useMemo } from 'react'

import PriceChange from '@/components/PriceChange'
import { CoinCategory } from '@/services/category'

import styles from '../styles.module.css'
import MarketCapColumn from './MarketCap'
import NameColumn from './Name'
import TopCoinsColumn from './TopCoins'
import VolumeColumn from './Volume'

export const defaultColumnProps: DataTableDefaultColumnProps<CoinCategory> = {
  titleClassName: `typography-body ${styles.tableHeader}`,
  cellsClassName: `typography-body-number ${styles.tableCell}`,
}

export function useColumns() {
  const t = useTranslations()
  return useMemo<DataTableColumn<CoinCategory>[]>(
    () => [
      {
        accessor: 'name',
        title: t('category.category'),
        sortKey: 'name',
        sortable: true,
        textAlign: 'left',
        minWidth: 180,
        render: (category: CoinCategory) => <NameColumn category={category} />,
      },
      {
        accessor: 'market_cap_native',
        title: t('coinTable.headers.marketCap'),
        textAlign: 'right',
        sortable: true,
        sortKey: 'market_cap_native',
        render: (category: CoinCategory) => <MarketCapColumn category={category} />,
      },
      {
        accessor: 'volume_24h_native',
        title: t('category.volume24h'),
        textAlign: 'right',
        sortable: true,
        sortKey: 'volume_24h_native',
        render: (category: CoinCategory) => <VolumeColumn category={category} />,
      },
      {
        accessor: 'percent_change_24h_native',
        title: t('coinTable.headers.24hChange'),
        textAlign: 'right',
        sortable: true,
        sortKey: 'percent_change_24h_native',
        render: (category: CoinCategory) => (
          <PriceChange value={Number(category.percent_change_24h_native) * 0.01} />
        ),
      },
      {
        accessor: 'highlighted_coins',
        title: t('category.topCoins'),
        textAlign: 'right',
        render: (category: CoinCategory) => <TopCoinsColumn category={category} />,
      },
    ],
    [t],
  )
}
